<template>
	<div class="eia-unit-switcher">
		<eia-link v-for="unit of units"
			:key="unit.id"
			@click="switchDisplayUnits( unit )">Change to {{ unit.displayLongName }}</eia-link>
	</div>
</template>

<script>
import { units } from '@/utils/math-utils';
import { mapState } from 'vuex';

export default {
	name: 'eia-unit-switcher',

	computed: {

		...mapState( 'stages', [ 'siteAreaDisplayUnits' ] ),

		units(){

			const availableUnits = [];

			for( const unit of Object.values( units ) ){

				if( unit.id !== this.siteAreaDisplayUnits.id ){
					availableUnits.push( unit );
				}

			}

			console.log( availableUnits );

			return availableUnits;
		},
	},

	methods: {

		switchDisplayUnits( unit ){

			const previousUnit = { ...this.siteAreaDisplayUnits };

			this.$store.commit( 'stages/switchAreaDisplayUnits', unit.id );

			this.$emit( 'switch', previousUnit, unit );

		},

	},

};
</script>

<style lang="scss" scoped>

	.eia-unit-switcher a{
		display: inline-block;
		margin-left: 10px;
		padding-right: 10px;
		border-right: 1px solid #333;

		&:last-child{
			border-right: none;
		}
	}

</style>
